import {
  computed, observable, makeObservable,
} from 'mobx';
import { Axios } from '../utilities/network';
import { isWeb } from '../utilities/platform';
import RootStore from './root-store';
import { navigate } from 'gatsby';
import { PAGE_SIZE, PendingInfo, UserInfo, VmList } from '../constants/options';
import { SetLocalStorage } from '../utilities/cryptography';
import { USER_INFO } from '../constants/storage-keys';

export default class UserStore {
  get isAuthed() {
    return isWeb && localStorage.getItem("USER_TOKEN") != null;
  }

  set isAuthed(value: boolean) {
    if (!value && isWeb) {
      console.log("Deleting auth data...");
      localStorage.removeItem("USER_TOKEN");
      localStorage.removeItem("USER_INFO");
      // localStorage.removeItem("WISHLIST");
    }
  }

  loading: boolean = false;
  signingIn: boolean = false;
  staffList: VmList = { totalCount: 0, items: [] };

  userToken: string | null = null;

  numPendings: number | null = null;

  rootStore: RootStore;

  constructor(rootStore: RootStore) {
    makeObservable(this, {
      isAuthed: computed,
      loading: observable,
      signingIn: observable,
      userToken: observable,
      staffList: observable,
      numPendings: observable,
    });
    this.rootStore = rootStore;
  }


  signIn = async (userModel: any) => {
    this.signingIn = true;
    try {
      const res = await Axios.post(`/api/Account/Login`, userModel);
      const token = `Bearer ${res.data.token}`;
      const user = res.data;
      this.userToken = user.token;
      if (isWeb) {
        localStorage.USER_TOKEN = token;
        let userInfo: UserInfo = {
          id: user.id,
          username: user.userName,
          address: user.address,
          gender: user.gender,
          dateOfBirth: user.dateOfBirth,
          firstName: user.firstName,
          lastName: user.lastName,
          schoolId: user.schoolId,
          email: user.email,
          role: user.role,
        };
        this.numPendings = user.pendingBookingRequests + user.pendingInvoiceApprovals + user.pendingMaintenanceRequests;
        SetLocalStorage(USER_INFO, userInfo);
      }
      console.log("User Info", res.data);
      return Promise.resolve(res.data);
    } catch (err) {
      this.isAuthed = false;
      return Promise.reject(err);
    } finally {
      this.signingIn = false;
    }
  };

  signOut = () => {
    this.isAuthed = false;
    this.userToken = null;
    navigate('/');
    this.rootStore.notify('Bye', "success");
  };

  signUp = async (userModel: any) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Account/Register`, userModel);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  // getStaffList = async (skip: number, reqModel: any) => {
  //   this.loading = true;
  //   try {
  //     const res = await Axios.post(`/api/Staff/Search/${skip}/${PAGE_SIZE}`, reqModel);
  //     this.staffList = res.data;
  //     console.log("Staff List", res.data);
  //     return Promise.resolve(res.data);
  //   } catch (err) {
  //     return Promise.reject(err);
  //   } finally {
  //     this.loading = false;
  //   }
  // };

  // getPendings = async () => {
  //   this.loading = true;
  //   try {
  //     const res = await Axios.get(`/api/Dashboard/Pending`);
  //     this.numPendings = res.data.pendingBookingRequests + res.data.pendingInvoiceApprovals + res.data.pendingMaintenanceRequests;
  //     return Promise.resolve(res.data);
  //   } catch (err) {
  //     return Promise.reject(err);
  //   } finally {
  //     this.loading = false;
  //   }
  // };

}
